import { EventCreatorMap } from '@app/analytics/models/helpers';
import * as MmaoActions from '@app/store/actions';

import MmaoCtaClick from './click-cta';
import MmaoAnswer from './answer';
import MmaoReject from './reject';
import MmaoSubmit from './submit';
import MmaoAccept from './validate';
import MmaoMakeOfferSuccess from './make-offer-success';

const eventsMap: EventCreatorMap = {
  [MmaoActions.MMAO_CTA_CLICK]: MmaoCtaClick,
  [MmaoActions.MMAO_CHAT_ANSWER]: MmaoAnswer,
  [MmaoActions.MMAO_REJECT]: MmaoReject,
  [MmaoActions.MMAO_SUBMIT]: MmaoSubmit,
  [MmaoActions.MMAO_ACCEPT]: MmaoAccept,
  [MmaoActions.MMAO_MAKE_OFFER_SUCCESS]: MmaoMakeOfferSuccess
};

export default eventsMap;
